<header class="tw-relative">
  <app-back-button class="tw-absolute back-btn"
    *ngIf="!currentUrl.includes('card-activation') && (onboardingType !== 'signup' || currentIndex !== 0)" />
  <app-starter-header-ts *ngIf="currentUrl.includes('/starter')" />
  <img *ngIf="currentUrl.includes('/advanced')" src="../../../assets/images/advanced-header-th.svg"
    alt="Advanced Header" />
  <app-verified-header-th *ngIf="currentUrl.includes('/verified')" />
</header>